import React from 'react';
import { Link } from 'react-router-dom';
import { Button, SectionContainer } from '@/components';
import { formatMessage } from '@/locales';
import GooglePlayImage from '@/assets/img/home/archero/google-play@2x.png';
import AwardArcheroMobile from '@/assets/img/home/archero/award_archero_mobile@2x.png';
import './home-content-archero.view.less';
import { LocalStorageService } from '@/services';
import Tool from '@/components/tool/tool';

const HomeContent2View = () => {
    const localId = LocalStorageService.get('localId') || 'en-US';
    const logonText = {
        'en-US': require('@/assets/img/home/archero/icon_game_archero@2x.png'),
        'zh-CN': require('@/assets/img/home/archero/logo_text_cn@2x.png')
    };

    return (
        <SectionContainer
            className="home-content-archero-view"
            imageRender={() => {
                return (
                    <picture>
                        <source
                            srcSet={require('@/assets/img/home/archero/home_page_archero_background@768.png')}
                            media="(max-width: 768px)"
                        />
                        <img
                            className="background-image"
                            src={require('@/assets/img/home/archero/background.png')}
                            alt=""
                        />
                    </picture>
                );
            }}
        >
            <div className="contentx">
                <h1 className="title">
                    <span className="logo-wrapper">
                        <img src={logonText[localId]} alt="" />
                    </span>
                    {/* <span className="text">
                        {formatMessage({ id: 'home.content2.archero.name' })}
                    </span> */}
                </h1>
                <div className="google-play-wrapper google-play-wrapper-pc">
                    <img src={GooglePlayImage} alt="" />
                </div>
                <p className="desc">
                    {formatMessage({ id: 'home.content.archero.description' })}
                </p>
                <div className="google-play-wrapper google-play-wrapper-mobile">
                    <img src={AwardArcheroMobile} alt="" />
                </div>
                <Tool
                    appleurl="https://apps.apple.com/gb/app/archero/id1453651052"
                    googleplayurl="https://play.google.com/store/apps/details?id=com.habby.archero&hl=en&gl=US"
                    detailPageId="archero"
                />
                {/* <a
                    className="abutBtnIos"
                    target="_target"
                    href="https://apps.apple.com/gb/app/archero/id1453651052"
                >
                    <img
                        className="jump-image"
                        src={require('./img/store.png')}
                        alt=""
                    />
                </a>
                <a
                    className="abutBtnA"
                    target="_target"
                    href="https://play.google.com/store/apps/details?id=com.habby.archero&hl=en&gl=US"
                >
                    <img
                        className="jump-image"
                        src={require('./img/play.png')}
                        alt=""
                    />
                </a>
                <Link to="/game/detail/archero">
                    <Button className="abut">
                        {formatMessage({ id: 'home.content2.buttonText' })}
                    </Button>
                </Link> */}
            </div>
        </SectionContainer>
    );
};

export default HomeContent2View;
